
export const foodStock = [
  {
    imageSrc: "https://images.fineartamerica.com/images/artworkimages/mediumlarge/2/sandwich-and-fries-foodad--multi-bits.jpg",
    title: "Sandwich and American Fries",
    description: "Dripped with relish and mayo-sweet deluxe sauce. Work on the alcohol-fuelled engine.",
    price: "35.99",
    isPopular: true,
    isHearty: false,
    isComfy: true
  },
  {
    imageSrc: "https://d2rd7etdn93tqb.cloudfront.net/wp-content/uploads/2021/12/shutterstock-classic-french-fries-121621.jpg",
    title: "American Classic Fries",
    description: "Dripped with relish and mayo-sweet deluxe sauce. Work on the alcohol-fuelled engine.",
    price: "35.99",
    isPopular: true,
        isHearty: true
  },

  {
    imageSrc: "https://www.modernhoney.com/wp-content/uploads/2019/08/Classic-Lasagna-14-scaled.jpg",
    title: "Lasagna",
    description: "Layers of rich meat sauce, creamy ricotta, and gooey melted cheese.",
    price: "35.99",
    isPopular: true
  },
  {
    imageSrc: "https://www.betterthanbouillon.com/wp-content/uploads/2021/11/philly-cheese-sandwich.png",
    title: "Chickenbake and American Fries",
    description: "Juicy chicken baked with herbs, served with crispy golden fries.",
    price: "35.99",
    isPopular: true
  },
  {
    imageSrc: "/img/anything-goes-quiche.jpg",
    title: "Anything Goes Quiche",
    description: "Flaky pastry crust filled with a medley of savory ingredients, baked to perfection.",
    price: "35.99",
    isPopular: false
  },
  {
    imageSrc: "img/berry-chicken-salad.jpg",
    title: "Berry Chicken Salad",
    description: "Succulent grilled chicken atop a bed of fresh greens, topped with vibrant berries.",
    price: "35.99",
    isPopular: true
  },
  {
    imageSrc: "img/chickpea-tuna-salad.jpg",
    title: "Chickpea Tuna Salad",
    description: "Hearty chickpeas and tender tuna tossed with crisp veggies in a zesty dressing.",
    price: "35.99",
    isPopular: true
  },
  {
    imageSrc: "img/garlic-roasted-eggplant.jpg",
    title: "Garlic Roasted Eggplant",
    description: "Tender eggplant slices roasted to perfection with aromatic garlic and herbs.",
    price: "35.99",
    isPopular: true
  },
  {
    imageSrc: "img/one-pan-salmon-and-vegetables.jpg",
    title: "One-Pan Salmon And Vegetables",
    description: "Succulent salmon fillets roasted with colorful veggies for a wholesome meal.",
    price: "35.99",
    isPopular: true
  },
  {
    imageSrc: "img/roasted-root-vegetables.jpg",
    title: "Roasted Root Vegetables",
    description: "Earthy root veggies roasted to caramelized perfection, bursting with flavor.",
    price: "35.99",
    isPopular: true
  },
  {
    imageSrc: "img/southwest-stuffed-sweet-potato.jpg",
    title: "Southwest Stuffed Sweet Potato",
    description: "Baked sweet potato loaded with spicy black beans, creamy avocado, and zesty salsa.",
    price: "35.99",
    isPopular: true
  },
  {
    imageSrc: "img/tomato-tart.jpg",
    title: "Tomato Tart",
    description: "Buttery pastry crust filled with juicy ripe tomatoes, fragrant herbs, and creamy cheese.",
    price: "35.99",
    isPopular: true
  },
  {
    imageSrc: "img/tuna-veggie-casserole.jpg",
    title: "Tuna Veggie Casserole",
    description: "Tender tuna and vibrant veggies baked in a creamy sauce, topped with crispy breadcrumbs.",
    price: "35.99",
    isPopular: true
  },
  {
    imageSrc: "img/vegetable-stir-fry.jpg",
    title: "Vegetable Stir Fry",
    description: "Crisp, colorful veggies stir-fried to perfection in a savory soy sauce.",
    price: "35.99",
    isPopular: true
  },
  {
    imageSrc: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTjUjo_QbWlUVAPsUt0xPdrgpMd0GdiZS74pxjhl9we0w&s",
    title: "Sloppy Joe",
    description: "Savory ground beef, tangy tomato sauce, and crispy onions on a warm bun.",
    price: "35.99",
    isPopular: true
  },
  {
    imageSrc: "https://saltedmint.com/wp-content/uploads/2024/01/Beef-stroganoff-with-rice-2.jpg",
    title: "Beef Stroganoff w/ Rice",
    description: "Tender beef strips in a creamy mushroom sauce served over fluffy rice.",
    price: "35.99",
    isPopular: true
  },
];
